module.exports = __webpack_public_path__ + "img/myt.f06d254d.svg";